/** Tipos de contratación del empleado (fijos; los tipos de contrato documental se configuran aparte). */
export const TIPOS_CONTRATACION_EMPLEADO = ['Planilla', 'Recibo por Honorarios'];

export const esTipoContratacionEmpleadoValido = (valor) =>
  TIPOS_CONTRATACION_EMPLEADO.includes(String(valor || '').trim());
